import debugInit from 'debug';
import utilApi from '@/api/bid/bidApi';

export default {
  name: 'captcha',
  mixins: [],
  extends: {},
  components: {},
  props: [],
  data() {
    return {
      captchaImg: null,
      captchaCode: null,
      captchaVerifyCode: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getCaptchaCode();
  },
  updated() {},
  beforeDestroy() {},
  methods: {
    async getCaptchaCode() {
      const result = await utilApi.getCaptchaCode();

      if (result != null) {
        this.captchaImg = `data:image/jpeg;base64,${result.data}`;
        this.captchaVerifyCode = result.text;
        this.captchaCode = null;
      }
    },
    verfiyCaptcha() {
      return (this.captchaVerifyCode === this.captchaCode);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/bid/captcha/captcha.js